import React, { Component } from "react";
import { Route, Switch, Redirect, BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Styles/app-theme.css";

import theme from "./theme";

// Components
import AppLayout from "./Components/Navigation/AppLayout";
import ScrollTop from "./Components/ScrollTop";
import Application from "./Components/Application";

// Pages
import MainPage from "./Pages/MainPage";
import Calculator from "./Pages/Calculator";
import KidsPage from "./Pages/KidsPage";
import KidsProfile from "./Pages/KidsProfile";
import NotFoundPage from "./Pages/404";
import UserProvider from "./providers/UserProvider";
import SessionsPage from "./Pages/SessionsPage";
import GroupsPage from "./Pages/GroupsPage";
import SessionsProfile from "./Pages/SessionsProfile";
import LocationsProfile from "./Pages/LocationsProfile";
import LocationsPage from "./Pages/LocationsPage";
import GroupSessionsForm from "./Components/GroupSessionsForm";
import TherapistSchedule from "./Pages/TherapistSchedule";

const SignInPage = () => (
  <UserProvider>
    <Application />
  </UserProvider>
);

class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <ScrollTop />
          <AppLayout>
            <Switch>
              <Route exact path="/" component={MainPage} />
              <Route exact path="/kids" component={KidsPage} />
              <Route exact path="/sessions" component={SessionsPage} />
              <Route exact path="/groups" component={GroupsPage} />
              <Route exact path="/locations" component={LocationsPage} />
              <Route exact path="/calculator" component={Calculator} />

              <Route exact path="/kids-profile" component={KidsProfile} />
              <Route exact path="/sessions-profile" component={SessionsProfile} />
              <Route exact path="/group-profile" component={GroupSessionsForm} />

              <Route exact path="/locations-profile" component={LocationsProfile} />
              <Route exact path="/schedule" component={TherapistSchedule} />

              <Route path="/sign-in" component={SignInPage} />
              <Route exact path="/404" component={NotFoundPage} />
              <Redirect to="/404" />
            </Switch>
          </AppLayout>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;
